import { render, staticRenderFns } from "./RecommendBestItem.vue?vue&type=template&id=ec0bc73e"
import script from "./RecommendBestItem.vue?vue&type=script&lang=js"
export * from "./RecommendBestItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports